module.exports = __webpack_public_path__ + "components/closing-infographics/static/infographic__mobile--AT-b9f97ebe1bf340e5ff34b04fa10f9435.jpg";